import React from 'react';
import PropTypes from 'prop-types';
import { map, get, includes, size, lowerCase } from 'lodash';
import * as Yup from 'yup';
import { Formik, Form, Field, FieldArray } from 'formik';
import moment from 'moment';
import { Text, Title, Divider, FormikInput, Accordion, Button, Checkbox, Loading, Row, ConditionalRender, FlexContainer, HasPermissions } from '../../common';
import GetABMResources from '../../graphql/getABMResources';
import CreateABMGroups from '../../graphql/createABMProfile';
import checkIfGroupNameExists from '../../graphql/checkIfGroupNameExists';
import { generateTraceabilityUtil, _get } from '../../../utils/misc';

const AutoData = ({ title, desc }) => (
    <>
        <Row>
            <Text semibold text={title} />
        </Row>
        <Row>
            <Text text={desc} />
        </Row>
    </>
);

const CreateDisplayProfileForm = ({ values, loading: formLoading, isValid, isSubmitting, errors }) => (
    <Form style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <FlexContainer direction='column' flex='1'>
            <Field
                component={FormikInput}
                label='Nombre de perfil'
                name='groupName'
                style={{ marginBottom: '15px' }}
      />
            <Divider />
            <Field
                component={FormikInput}
                label='Descripción'
                name='groupDescription'
                textArea
                style={{ marginBottom: '15px' }}
      />
            <Divider style={{ marginBottom: '15px' }} />
            <GetABMResources>
                {({ data, loading }) => (
                    <Loading loading={loading}>
                        <Title text='create_profile_form.permissions.title' />
                        <FlexContainer direction='column'>
                            {
                map(data, ({ id, roleName, name, resources }, index) => (
                    <Accordion title={<Text text={name} />} background='white' closedBackground='white' defaultOpened={index === 0 || size(get(values, id))}>
                        <FieldArray name={id} render={({ insert, remove, push }) => (
                            map(resources, (item, index) => (
                                <Checkbox
                                    label={item}
                                    key={index}
                                    defaultChecked={includes(get(values, id), item)}
                                    onChange={(checked) => {
                                        const elIndex = (get(values, id, [])).findIndex((i) => i === item);
                                        checked && (elIndex === -1) ? push(item) : remove(elIndex, item);
                                    }} />
                            ))
                        )} />
                    </Accordion>
                ))
              }
                        </FlexContainer>
                    </Loading>
                )}
            </GetABMResources>
        </FlexContainer>
        <Divider margin='10' />
        <ConditionalRender condition={get(values, 'id')}>
            <AutoData title='Fecha de creación' desc={_get(values, 'createdIn') ? moment(_get(values, 'createdIn')).format('DD-MM-YYYY HH:mm:ss') : '-'} />
            <Divider />
            <AutoData title='Fecha de modificación' desc={_get(values, 'updatedIn') ? moment(_get(values, 'updatedIn')).format('DD-MM-YYYY HH:mm:ss') : '-'} />
            <Divider />
            <AutoData title='Modificado por' desc={_get(values, 'createdBy')} />
        </ConditionalRender>
        <Divider margin='10' />
        <HasPermissions to={['profiles-page:edit']}>
            <Row justify='flex-end' mB={10}>
                <Button link text='Cancelar' htmlType='reset' width={100} />
                <Button width={100} htmlType='submit' loading={formLoading || isSubmitting} disabled={isSubmitting | !isValid}>Guardar</Button>
            </Row>
        </HasPermissions>
    </Form>
);
class CreateProfileForm extends React.Component {
  state = { activeProduct: null }

  handleReset = () => {
      const { onReset } = this.props;
      console.log('should reset');
      onReset();
  }

  onModifyProfile = async (client, editMode) => {
      if (editMode) return await generateTraceabilityUtil(client, { actionId: 11 });
  };

  handleSubmit = (values, { setSubmitting, ...props }) => {
      const { createGroup, onSubmitSuccess, editMode, client } = this.props;
      console.log('should submit', props);
      const { groupName, groupDescription, createdIn, updatedIn, createdBy, id, ...scopes } = values;
      const permissions = map(scopes, (accesses, key) => {
          return { id: key, accesses };
      });
      setSubmitting(true);
      this.onModifyProfile(client, editMode); 
      createGroup({ variables: { input: { id, groupName, createdBy, groupDescription, permissions } } })
          .then((response) => {
              setSubmitting(false);
              onSubmitSuccess();
          })
          .catch((err) => {
              console.log(err);
              setSubmitting(false);
          });
  }

  _validateGroupName = (client, initialValue) => {
      return (groupName, ...props) => {
          return checkIfGroupNameExists({ client, variables: { groupName } }).then((groupNames) => {
              return Promise.resolve(!includes(groupNames, lowerCase(groupName)) || groupName === initialValue);
          });
      };
  }

  _getValidationSchema = () => {
      const { client, initialValues } = this.props;
      const ValidationSchema = Yup.object().shape({
          groupName: Yup.string()
              .min(3, 'form.validations.min_length')
              .max(50, 'form.validations.max_length')
              .required('form.validations.required')
              .test('checkDuplUsername', 'form.validations.unique_group', this._validateGroupName(client, get(initialValues, 'groupName'))),
          groupDescription: Yup.string()
              .min(3, 'form.validations.min_length')
              .max(255, 'form.validations.textarea.max_length')
              .required('form.validations.required')
      });

      return ValidationSchema;
  }
  render () {
      const { initialValues } = this.props;
      return (
          <Formik
              validationSchema={this._getValidationSchema()}
              onSubmit={this.handleSubmit}
              onReset={this.handleReset}
              initialValues={initialValues}
              render={CreateDisplayProfileForm}
      />
      );
  }
}

CreateProfileForm.defaultProps = {
    editMode: false,
    values: {},
    initialValues: {}
};

CreateProfileForm.propTypes = {
    editMode: PropTypes.bool,
    initialValues: PropTypes.object,
    client: PropTypes.object,
    createGroup: PropTypes.func,
    onSubmitSuccess: PropTypes.func
};
export default (props) => (
    <CreateABMGroups>
        {({ updateFn, loading, client }) => (
            <CreateProfileForm createGroup={updateFn} client={client} {...props} />
        )}
    </CreateABMGroups>
);
